"use strict";

/**
 * The contents of this file are subject to the terms of the Common Development and
 * Distribution License (the License). You may not use this file except in compliance with the
 * License.
 *
 * You can obtain a copy of the License at legal/CDDLv1.0.txt. See the License for the
 * specific language governing permission and limitations under the License.
 *
 * When distributing Covered Software, include this CDDL Header Notice in each file and include
 * the License file at legal/CDDLv1.0.txt. If applicable, add the following below the CDDL
 * Header, with the fields enclosed by brackets [] replaced by your own identifying
 * information: "Portions copyright [year] [name of copyright owner]".
 *
 * Copyright 2016 ForgeRock AS.
 */

define('org/forgerock/openam/ui/common/util/ExternalLinks',["lodash"], function (_) {
    var backstageDocsUrl = "https://backstage.forgerock.com/#!/docs/openam/13.5/";

    return {
        backstage: {
            authz: _.mapValues({
                policySets: "#configure-apps-with-console",
                policies: "#configure-policies-with-console",
                resourceTypes: "#configure-resource-types-with-console"
            }, function (hash) {
                return backstageDocsUrl + "admin-guide" + hash;
            }),
            config: {
                services: backstageDocsUrl + "reference#chap-config-ref"
            }
        }
    };
});

